import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorHandler } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class LocationHotelBusinessService {

  public hotelBusinessLocations$: Subject<any> = new Subject();
  public hotelBusinessItem$: Subject<any> = new Subject();

  constructor(
    private _http: HttpClient,
    private _errorService: ErrorHandler
  ) {}

  getLocationData(value: string, country: string) {
    const params = new HttpParams()
      .set('input', value)
      .set('country', country);

    this._http.get('/api/autocomplete', { params })
      .pipe(
        catchError(error => {
          this._errorService.handleError(error);
          return [];
        })
      )
      .subscribe((res: any) => {
        if (res.status === 'ZERO_RESULTS') {
          this.hotelBusinessLocations$.next(res.status);
          this._errorService.handleError(res.status);
          return;
        }

        if (res.status !== 'OK') {
          this.hotelBusinessLocations$.next(res.status);
          this._errorService.handleError(res.status);
          return;
        }

        this.hotelBusinessLocations$.next(res.predictions);
      });
  }

  setLocationSelection(data: Object) {
    this.hotelBusinessItem$.next(data);
  }
}
